export const PLAYLIST_SCHEMA_VERSION = 1;

// Imported playlists carry a fixed, tiny `updatedAt` instead of the server's date. A TV whose clock is wrong
// would otherwise stamp a deletion "older" than the record it deleted, and the playlist would come back.
// The server copy ranks just above the local cache of it. The server's date is kept for display only.
export const LEGACY_LOCAL_UPDATED_AT = 0;
export const LEGACY_SERVER_UPDATED_AT = 1;

// tv = added on this device, legacy-local = the old `playlists` key, legacy-server = the register_device list
export const PLAYLIST_ORIGINS = ["tv", "legacy-local", "legacy-server"];
